import React from 'react';
import {
  CustomerIcon,
  DocumentationIcon,
  HelpIcon,
  OverviewIcon,
  PayoutIcon,
  ProductIcon,
  TerminalIcon,
  TransactionsIcon,
  WalletIcon,
} from 'components/icons';

import {
  ACTIVITYLOG,
  CUSTOMERS,
  CUSTOMER_CATEGORIES,
  DEVICES,
  DOCUMENTATION,
  GUIDES,
  INDEX,
  PRODUCTS,
  REFERRAL,
  SETTINGS,
  SETTLEMENT,
  TEAMS,
  TERMINAL,
  TRANSACTIONS,
  WALLET,
} from 'router/routes';
import { useSelector } from 'react-redux';
import styles from './menuitem/menuitem.module.scss';

const useSideBarData = () => {
  const user = useSelector((state) => state.common.user);
  const role = user?.merchantUser?.role;
  return [
    {
      id: 1,
      name: 'Overview',
      path: INDEX,
      show: true,
      icon: <OverviewIcon />,
    },
    {
      id: 2,
      name: 'Products',
      path: PRODUCTS,
      show: role === 'OWNER' || role === 'ADMIN',
      icon: <ProductIcon className={styles.strokeOnly} />,
    },
    {
      id: 3,
      name: 'Transactions',
      path: TRANSACTIONS,
      show: true,
      icon: <TransactionsIcon />,
    },
    {
      id: 4,
      name: 'Wallet',
      path: WALLET,
      show: role !== 'SUPPORT_OFFICER',
      icon: <WalletIcon />,
    },
    {
      id: 5,
      name: 'Settlement',
      path: SETTLEMENT,
      show: true,
      icon: <PayoutIcon />,
    },

    {
      id: 6,
      name: 'Terminal',
      path: TERMINAL,
      show: true,
      icon: <TerminalIcon />,
    },

    {
      id: 7,
      name: 'Customers',
      path: CUSTOMERS,
      show: true,
      icon: <CustomerIcon />,
      subMenu: [
        {
          id: 71,
          name: 'Customers List',
          path: CUSTOMERS,
          show: true,
        },
        {
          id: 72,
          name: 'Categories',
          path: CUSTOMER_CATEGORIES,
          show: true,
        },
      ],
    },

    {
      id: 8,
      name: 'Documentation',
      path: window._env_.REACT_APP_DOCS,
      show: true,
      isExternal: true,
      icon: <DocumentationIcon />,
    },
    {
      id: 9,
      name: 'Guides',
      path: GUIDES,
      show: true,
      icon: <HelpIcon />,
    },
  ];
};
export default useSideBarData;
